import { useCallback, useEffect, useState } from "react";

import LockIcon from "@assets/icons/lock-closed.svg";

import { MEETING_TOOLTIP_TEXT } from "@config/constants";
import { OrganizationLogo } from "@ui/Logos";
import { Switch } from "@ui/Switch";

interface Props {
  isPrivate: boolean;
  onUpdate: (value: boolean) => void;
  isDisabled?: boolean;
}

export function PrivacySwitcher({ isPrivate, onUpdate, isDisabled = false }: Props) {
  const [privateState, setPrivateState] = useState(isPrivate);

  const handleTogglePrivateState = useCallback(() => {
    const next = !privateState;
    setPrivateState(next);
    onUpdate(next);
  }, [onUpdate, privateState, isPrivate]);

  useEffect(() => {
    setPrivateState(isPrivate);
  }, [isPrivate]);

  return (
    <Switch
      isDisabled={isDisabled}
      state={privateState}
      leftContent={
        <div className="-ml-[1px] flex items-center gap-1">
          <OrganizationLogo />
        </div>
      }
      rightContent={
        <div className="-mr-[1px] flex items-center gap-1">
          <LockIcon width={20} height={20} />
        </div>
      }
      onToggle={handleTogglePrivateState}
      circleWidth={32}
      switchWidth={70}
      leftTooltip={MEETING_TOOLTIP_TEXT.shared}
      rightTooltip={MEETING_TOOLTIP_TEXT.private}
      leftTooltipPlacement="bottom"
      rightTooltipPlacement="bottom"
      rightTooltipContentClassName="w-48"
    />
  );
}
